import { withDependencies } from '@wix/thunderbolt-ioc'
import { IPageDidMountHandler, IPageWillUnmountHandler, IPageDidUnmountHandler } from '@wix/thunderbolt-symbols'
import { ShouldObserveHeaderHandlerSymbol, StickyToComponentSymbol } from './symbols'
import { IShouldObserveHeaderHandler, IStickyToComponent } from './types'

export const HeaderObserverHandler = withDependencies(
	[ShouldObserveHeaderHandlerSymbol, StickyToComponentSymbol],
	(
		shouldObserveHeaderHandler: IShouldObserveHeaderHandler,
		{ initHeaderObserver, destroyHeaderObserver, restoreHeaderHeightVar }: IStickyToComponent
	): IPageDidMountHandler & IPageWillUnmountHandler & IPageDidUnmountHandler => {
		return {
			pageDidMount() {
				if (shouldObserveHeaderHandler.shouldObserveHeader) {
					initHeaderObserver()
				}
			},
			pageWillUnmount() {
				if (shouldObserveHeaderHandler.shouldObserveHeader) {
					destroyHeaderObserver()
				}
			},
			pageDidUnmount() {
				if (shouldObserveHeaderHandler.shouldObserveHeader) {
					restoreHeaderHeightVar()
				}
			},
		}
	}
)
